export default __webpack_public_path__ + "static/media/ai.0bdade52.png";